import FullCalendar from './FullCalendar.vue'

export default {
  install: function (Vue, options) {
    Vue.component('full-calendar', FullCalendar)
  }
}
export { FullCalendar }
